// extracted by mini-css-extract-plugin
module.exports = {"Select-animation-fadeIn":"FzaSk5uRZ8qahJL7naSgX","Select-animation-spin":"HgBoBTzMt5_T2mTD9mAok"};